import {
  SET_ACCORDION_IS_LOADED,
  SET_DASHBOARD_IS_LOADED,
  SET_HOMEPAGE_STORIES_IS_LOADED,
  SET_HOMEPAGE_FC_UPDATES_IS_LOADED,
  SET_SEARCH_RESULTS_LOADED,
  SET_HIDE_OVERRIDE
} from './types'

export const setAccordionIsLoaded = (isLoaded: boolean): { type: typeof SET_ACCORDION_IS_LOADED, isLoaded: boolean } => ({
  type: SET_ACCORDION_IS_LOADED,
  isLoaded
})

export const setDashboardIsLoaded = (isLoaded: boolean): { type: typeof SET_DASHBOARD_IS_LOADED, isLoaded: boolean } => ({
  type: SET_DASHBOARD_IS_LOADED,
  isLoaded
})

export const setHomePageStoriesIsLoaded = (isLoaded: boolean): { type: typeof SET_HOMEPAGE_STORIES_IS_LOADED, isLoaded: boolean } => ({
  type: SET_HOMEPAGE_STORIES_IS_LOADED,
  isLoaded
})

export const setHomePageFcUpdatesIsLoaded = (isLoaded: boolean): { type: typeof SET_HOMEPAGE_FC_UPDATES_IS_LOADED, isLoaded: boolean } => ({
  type: SET_HOMEPAGE_FC_UPDATES_IS_LOADED,
  isLoaded
})

export const setSearchResultsLoaded = (isLoaded: boolean): { type: typeof SET_SEARCH_RESULTS_LOADED, isLoaded: boolean } => ({
  type: SET_SEARCH_RESULTS_LOADED,
  isLoaded
})

// With AoL we can 404 on pages that exist but aren't available to the current user
export const setHideOverride = (hideOverride: boolean): { type: typeof SET_HIDE_OVERRIDE, hideOverride: boolean } => ({
  type: SET_HIDE_OVERRIDE,
  hideOverride
})
